/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Button } from '@mui/material';

import { LoginOptionsProps } from '../../Models/Login.Model';

import { Icons } from '../../../../Shared/Constants/Icons';
import awsConfig from '../../../../Configuration/environment-config';

import {
  LoginWithYourText,
  EmailAndPhoneNoContainer,
  EmailAndPhoneNoText,
  EmailButtonStyles,
  PhoneNumberButtonStyles,
  MicrosoftButtonStyles,
  LinearGradientContainer,
  OrText,
} from './LoginPage.Style';

const STANDARD_PROVIDERS = ['FACEBOOK', 'GOOGLE', 'APPLE'];
const microsoftProvider: string | undefined = (awsConfig.aws_cognito_social_providers as string[])?.find(
  (p) => !STANDARD_PROVIDERS.includes(p.toUpperCase())
);

const LoginOptions: React.FC<LoginOptionsProps> = (props) => {
  const { onClick, signInUsing, t } = props;

  return (
    <>
      <LoginWithYourText>{t('signIn:signInWith')}</LoginWithYourText>
      <EmailAndPhoneNoContainer>
        <Button
          sx={{
            ...EmailButtonStyles,
          }}
          onClick={() => onClick(true, 'email')}>
          <img src={Icons.EmailIcon} alt={t('altTexts:emailLogo')} />
          <EmailAndPhoneNoText>{t('signIn:emailLabel')}</EmailAndPhoneNoText>
        </Button>
        <Button
          sx={{
            ...PhoneNumberButtonStyles,
          }}
          onClick={() => onClick(true, 'phoneNumber')}>
          <img src={Icons.PhoneNoIcon} alt={t('altTexts:phoneNumber')} />
          <EmailAndPhoneNoText>{t('signIn:phoneNumberLabel')}</EmailAndPhoneNoText>
        </Button>
      </EmailAndPhoneNoContainer>
      <LinearGradientContainer >
        <img src={Icons.LinearGradientLeftImg} alt="" />
        <OrText>{t('signIn:or')}</OrText>
        <img src={Icons.LinearGradientRightImg} alt="" />
      </LinearGradientContainer>
      {microsoftProvider && (
        <Button
          sx={{
            ...MicrosoftButtonStyles
          }}
          onClick={() => signInUsing(microsoftProvider)}>
          <img src={Icons.MicrosoftIcon} alt={t('altTexts:microsoftLogo')} />
          <EmailAndPhoneNoText>{t('signIn:signInWithMicrosoft')}</EmailAndPhoneNoText>
        </Button>
      )}
    </>
  );
};

export default withTranslation(['signIn', 'altTexts'])(LoginOptions);
